(() => {
  const playVideo = (slider) => {
    if (slider.swiper) {
      const sliderSwiper = slider.swiper;
      if (sliderSwiper.slides[sliderSwiper.previousIndex]) {
        const videoPrev = sliderSwiper.slides[
          sliderSwiper.previousIndex
        ].querySelector(".media-banner-slider__video video");
        if (videoPrev) {
          videoPrev.pause();
        }
      }
      if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
        const videoActive = sliderSwiper.slides[
          sliderSwiper.activeIndex
        ].querySelector(".media-banner-slider__video video");
        if (videoActive) {
          videoActive.play();
        }
      }
    }
  };
  const stopVideo = (slider) => {
    if (slider.swiper) {
      const sliderSwiper = slider.swiper;
      if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
        const videoActive = sliderSwiper.slides[
          sliderSwiper.activeIndex
        ].querySelector(".media-banner-slider__video video");
        if (videoActive) {
          videoActive.pause();
        }
      }
    }
  };
  const animateSlideContent = (slide) => {
    if (!slide) return;
    const contentGroup = slide.querySelector(
      ".media-banner-slider__content-group"
    );
    if (!contentGroup) return;
    contentGroup.classList.remove("slide-content-animate");
    void contentGroup.offsetWidth;
    contentGroup.classList.add("slide-content-animate");
  };
  const initSlider = (section) => {
    if (!section || !section?.classList.contains("section-media-banner-slider"))
      return;
    const box = section.querySelector(".media-banner-slider");
    if (box) {
      const swiperParams = {
        autoHeight: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
      };
      if (box.getAttribute("data-autoplay") === "true") {
        swiperParams.autoplay = {
          disableOnInteraction: true,
          pauseOnMouseEnter:
            box.getAttribute("data-stop-on-hover") === "true" ? true : false,
        };
      }
      if (box.getAttribute("data-loop") === "true") {
        swiperParams.loop = true;
        swiperParams.loopPreventsSliding = false;
      }
      if (box.getAttribute("data-pagination") === "true") {
        const paginationEl = box.querySelector(".swiper-pagination");
        swiperParams.pagination = {
          el: paginationEl,
          type: "bullets",
          clickable: true,
        };
      }
      if (box.getAttribute("data-navigation") === "true") {
        const nextEl = box.querySelector(
          ".media-banner-slider__nav-button--next"
        );
        const prevEl = box.querySelector(
          ".media-banner-slider__nav-button--prev"
        );
        swiperParams.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }
      if (box.getAttribute("data-parallax") === "true") {
        swiperParams.parallax = true;
      }
      if (box.getAttribute("data-animation-type") === "fade") {
        swiperParams.effect = "fade";
        swiperParams.speed = 400;
      } else {
        swiperParams.effect = "slide";
        swiperParams.speed = 800;
      }
      if (box.getAttribute("data-full-width") === "false") {
        swiperParams.breakpoints = {
          990: {
            spaceBetween: 0,
          },
        };
      }
      const slider = box.querySelector(".media-banner-slider__swiper");
      const swiperMedia = new Swiper(slider, {
        ...swiperParams,
      });
      setTimeout(() => {
        animateSlideContent(swiperMedia.slides[swiperMedia.activeIndex]);
      }, 100);
      swiperMedia.on("slideChangeTransitionEnd", (swiper) => {
        swiper.slides.forEach((slide) => {
          const contentGroup = slide.querySelector(
            ".media-banner-slider__content-group"
          );
          if (contentGroup) {
            contentGroup.classList.remove("slide-content-animate");
          }
        });
        animateSlideContent(swiper.slides[swiper.activeIndex]);
      });
    }
  };
  const initSection = (section) => {
    if (!section || !section?.classList.contains("section-media-banner-slider"))
      return;
    let slider = section.querySelector(".media-banner-slider__swiper");
    if (!slider) return;
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (slider) {
            playVideo(slider);
            if (
              slider.swiper &&
              slider.getAttribute("data-autoplay") === "true"
            ) {
              slider.swiper.autoplay.resume();
            }
          }
        } else {
          if (slider) {
            stopVideo(slider);
            if (
              slider.swiper &&
              slider.getAttribute("data-autoplay") === "true"
            ) {
              slider.swiper.autoplay.pause();
            }
          }
        }
      });
    });
    sectionObserver.observe(section);
  };
  const initScrollToExplore = (section) => {
    if (!section || !section?.classList.contains("section-media-banner-slider"))
      return;
    const scrollBtn = section.querySelector(
      ".media-banner-slider__explore-btn"
    );
    if (!scrollBtn) return;
    const nextSection = section.nextElementSibling;
    scrollBtn.addEventListener("click", () => {
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: "smooth" });
        return;
      }
      section.scrollIntoView({ behavior: "smooth" });
    });
    scrollBtn.addEventListener("keydown", (event) => {
      if (nextSection && event.key === "Enter") {
        nextSection.scrollIntoView({ behavior: "smooth" });
        return;
      }
      section.scrollIntoView({ behavior: "smooth" });
    });
  };
  initSlider(document.currentScript.parentElement);
  initSection(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
    initSection(event.target);
  });
})();
